import styled from "styled-components";

const JobsCompWrapper = styled.div`
  /* border: 2px solid red; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media screen and (max-width: 820px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 420px) {
    gap: 8px;
  }
`;

export default JobsCompWrapper;
